import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerPecPostaElettronicaCertificataModalComponent} from './worker-pec-posta-elettronica-certificata-modal';


export const WorkerPecPostaElettronicaCertificataModalModule: string = ng
  .module('worker-pec-posta-elettronica-certificata-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('workerPecPostaElettronicaCertificataModalComponent', WorkerPecPostaElettronicaCertificataModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-pec-posta-elettronica-certificata-modal/worker-pec-posta-elettronica-certificata-modal.module.ts